module.exports = __webpack_public_path__ + "static/media/Santeria_Poster.d24659cb.pdf";